import { NavLink } from "react-router";

import { twMerge } from "tailwind-merge";

import FaceId from "shared/assets/svg/face-id.svg?react";
import GalacticaLogo from "shared/assets/svg/galactica-logo.svg?react";
import Profile from "shared/assets/svg/profile.svg?react";

import { NavItem } from "./nav-item";

type Props = {
  className?: string;
};

export const NavBar = (props: Props) => {
  const { className } = props;

  return (
    <div
      className={twMerge(
        "pb-safe sticky right-0 bottom-0 left-0 flex items-end justify-center gap-x-12 bg-white px-2.5 py-4",
        className
      )}
    >
      <NavLink to="/my-certs">
        {({ isActive }) => {
          return (
            <NavItem
              isActive={isActive}
              title="My Certs"
              icon={<FaceId className="size-7.5" />}
            />
          );
        }}
      </NavLink>

      <NavLink to="/">
        {({ isActive }) => {
          return (
            <NavItem
              isActive={isActive}
              title="Home"
              icon={<GalacticaLogo className="text-persianOrange size-12" />}
            />
          );
        }}
      </NavLink>

      <NavLink to="/profile">
        {({ isActive }) => {
          return (
            <NavItem
              isActive={isActive}
              title="Profile"
              icon={<Profile className="size-7.5" />}
            />
          );
        }}
      </NavLink>
    </div>
  );
};
